export interface createCATModulos{
    id:number;
    tema:string;
    modulo:string;
    catCursosId: string;
}

export class createCATModulos implements createCATModulos{
    constructor(init?:createCATModulosFormValues){
        Object.assign(this,init);
    }
}

export class createCATModulosFormValues{
    id: number=0;
    tema: string = "";
    modulo: string = "";
    catCursosId:  string = "";

    constructor(createCATModulos?:createCATModulosFormValues){
        if(createCATModulos){
            this.id=createCATModulos.id;
            this.tema=createCATModulos.tema;
            this.modulo = createCATModulos.modulo;
            this.catCursosId = createCATModulos.catCursosId;
        }
    }
}